// extracted by mini-css-extract-plugin
export default {"html_content":"HtmlContent-module_html_content___9Siu","indented_container":"HtmlContent-module_indented_container___cLYZ","container":"HtmlContent-module_container__XHBjA"};